// 设备状态
export const deviceStatusMap = new Map<string, string>()
deviceStatusMap.set('1', '在线')
deviceStatusMap.set('2', '离线')

// 分配状态
export const allocateStatusMap = new Map<string, string>()
allocateStatusMap.set('1', '未分配')
allocateStatusMap.set('2', '已分配')
